import { approvedMeetingRequest, getAllMeetingRequests, rejectMeetingRequest } from "../controllers/meetingRequestController";

export const handleGetAllMeetingRequests = async (options = {}) => {
  const { response, lastVisible, firstVisible } = await getAllMeetingRequests(options);
console.log("op",options)
  
  return {
    response,
    firstDoc: firstVisible?.id,
    lastDoc: lastVisible?.id || null,
  };
};

export const handleRejectMeetingRequest = async(meetingRequestId, approvedById)=>{
    if (!meetingRequestId || !approvedById) {
        throw new Error("Meeting request ID and approved by ID are required.");
    }
    
    const response = await rejectMeetingRequest(meetingRequestId, approvedById);
    
    return {
        message: "Meeting Request rejected successfully",
        response: response
    }
};

export const handleApprovedMeeingRequest = async(meetingRequestId, approvedById, assigneeId) =>{
const response = await approvedMeetingRequest(meetingRequestId, approvedById, assigneeId);
return {
    message: "Meeting Request approved successfully",
    response:response
}
}